import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Login from '../../components/Login';
import api3000 from '../../services/api3000';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  padding: 20px;
  background-color: #fff;
`;

const LoginBox = styled.div`
  position: relative; /* para posicionar a logo absoluta aqui dentro */
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 320px;
  text-align: center;

  @media (max-width: 480px) {
    padding: 20px;
  }
`;

const LogoImg = styled.img`
  width: 100%;
  max-width: 380px;           
  pointer-events: none; 
  user-select: none;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  position: relative; /* para ficar acima da logo */
  z-index: 1;
`;

const LoginPage = () => {
  const navigate = useNavigate();

  const handleLogin = async (email, senha, setError) => {
    try {
      const response = await api3000.post('/auth/login', { email, senha });
      const data = response.data;

      const { token, user } = data;

      if (!token || !user?.nivel_acesso) {
        throw new Error('Resposta inválida do servidor. Token ou nível de acesso ausente.');
      }

      console.log(user)

      if (user.status === 'inativo') {
        setError('Usuário desativado. Entre em contato com o administrador.');
        return;
      }

      localStorage.setItem('token', token);
      localStorage.setItem('role', user.nivel_acesso);
      localStorage.setItem('userId', user.id);

      navigate('/dashboard');
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      const message = error.response?.data?.error || error.message || 'Erro ao conectar com o servidor';
      setError(message);
    }
  };

  return (
    <LoginContainer>
      <LogoImg src="/logo.png" alt="Logo" />
      <LoginBox>
        <Title>Login</Title>
        <Login handleLogin={handleLogin} />
      </LoginBox>
    </LoginContainer>
  );
};

export default LoginPage;
